package com.yogaaicoach.pages.workout.workout.ui

enum class WorkoutState {
    NOT_STARTED,
    IN_PROGRESS,
    PAUSED,
    COMPLETED;

    // Possible states for future
//    Scheduled: For workouts that are planned but haven’t started yet.
//    Cancelled: For workouts that were planned but won’t be completed.
//    Resumed: For workouts that were paused and then continued.
//    Abandoned: For workouts that were started but not completed.
}